/**
 * @generated SignedSource<<90a5ed531f9e7ee73166a95e2dfe991b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemWorkspacePill$data = {
  readonly id: string;
  readonly logo: string;
  readonly name: string;
  readonly " $fragmentType": "AutoRecordRulesListItemWorkspacePill";
};
export type AutoRecordRulesListItemWorkspacePill$key = {
  readonly " $data"?: AutoRecordRulesListItemWorkspacePill$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemWorkspacePill">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemWorkspacePill",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logo",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "89aae8792d8133c604cdf13b39acaab0";

export default node;
